<div class="about-us-container">
  <!-- Hero Section -->
  <section class="flex justify-content-center px-3 mt-5 mb-6">
    <div class="text-center">
      <h1 class="text-4xl font-semibold text-700 letter-spacing">
        About Coinwush
      </h1>
      <div
        class="mt-4 text-muted opacity-70 line-height-3 font-medium letter-spacing text-lg"
      >
        Empowering Indian traders with institutional-grade crypto derivatives
      </div>
    </div>
  </section>

  <!-- Mission Section -->
  <section
    class="flex justify-content-center flex-wrap gap-5 px-3 bg-white py-6"
  >
    <div class="w-full text-center px-2">
      <h2 class="text-2xl font-semibold text-700">Our Mission</h2>
      <div
        class="mt-4 text-muted opacity-70 line-height-3 font-medium max-w-70rem mx-auto"
      >
        At Coinwush, we're bridging the gap between traditional F&O trading and
        the digital asset revolution. Our mission is to provide Indian traders
        with a compliant, secure, and professional platform to trade crypto
        derivatives using INR—without the need to own cryptocurrency.
      </div>
    </div>
  </section>

  <!-- Values Section -->
  <section class="flex justify-content-center flex-wrap gap-5 mt-6 px-3 pb-6">
    <div class="w-full text-center">
      <h2 class="text-2xl font-semibold text-700 mb-5">What We Stand For</h2>
      <div class="flex flex-wrap justify-content-center gap-4 mt-4">
        <!-- Value Card 1 -->
        <div
          class="p-4 border-1 border-100 border-round-lg bg-white box"
          style="max-width: 20rem"
        >
          <div
            class="msg border-round-md flex align-items-center justify-content-center mx-auto"
            style="width: 50px; height: 50px"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-shield icon-dual-success"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <div class="mt-3 font-semibold text-lg text-700">
            Trust & Security
          </div>
          <div class="mt-2 opacity-70 text-muted line-height text-sm">
            Your safety is our priority. We employ bank-grade encryption,
            multi-factor authentication, and 24/7 monitoring to protect your
            assets and data.
          </div>
        </div>

        <!-- Value Card 2 -->
        <div
          class="p-4 border-1 border-100 border-round-lg bg-white box"
          style="max-width: 20rem"
        >
          <div
            class="border-round-md flex align-items-center justify-content-center mx-auto msg"
            style="width: 50px; height: 50px"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-bell icon-dual-info"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <div class="mt-3 font-semibold text-lg text-700">Transparency</div>
          <div class="mt-2 opacity-70 text-muted line-height text-sm">
            No hidden fees, no surprises. We believe in clear communication and
            honest pricing so you can trade with confidence.
          </div>
        </div>

        <!-- Value Card 3 -->
        <div
          class="p-4 border-1 border-100 border-round-lg bg-white box"
          style="max-width: 20rem"
        >
          <div
            class="bg-soft-orange border-round-md flex align-items-center justify-content-center mx-auto"
            style="width: 50px; height: 50px"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-sliders icon-dual-orange"
            >
              <line x1="4" y1="21" x2="4" y2="14"></line>
              <line x1="4" y1="10" x2="4" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12" y2="3"></line>
              <line x1="20" y1="21" x2="20" y2="16"></line>
              <line x1="20" y1="12" x2="20" y2="3"></line>
              <line x1="1" y1="14" x2="7" y2="14"></line>
              <line x1="9" y1="8" x2="15" y2="8"></line>
              <line x1="17" y1="16" x2="23" y2="16"></line>
            </svg>
          </div>
          <div class="mt-3 font-semibold text-lg text-700">Innovation</div>
          <div class="mt-2 opacity-70 text-muted line-height text-sm">
            We continuously evolve our platform with cutting-edge features,
            real-time analytics, and smart tools designed for serious traders.
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Why Choose Us Section -->
  <section class="bg-white py-6 px-3">
    <div class="text-center">
      <h2 class="text-2xl font-semibold text-700">Why Choose Coinwush?</h2>
      <div class="flex flex-wrap justify-content-center gap-6 mt-5">
        <div class="text-left" style="max-width: 25rem">
          <div class="flex align-items-start gap-3">
            <div
              class="msg border-round-md flex align-items-center justify-content-center"
              style="width: 40px; height: 40px; flex-shrink: 0"
            >
              <i class="pi pi-chart-line" style="font-size: 1.2rem"></i>
            </div>
            <div>
              <div class="font-semibold text-700">Built for Pro Traders</div>
              <div class="mt-2 opacity-70 text-muted line-height text-sm">
                Leverage your F&O expertise in crypto markets with daily,
                weekly, and monthly expiries tailored to your trading strategy.
              </div>
            </div>
          </div>
        </div>

        <div class="text-left" style="max-width: 25rem">
          <div class="flex align-items-start gap-3">
            <div
              class="border-round-md flex align-items-center justify-content-center msg"
              style="width: 40px; height: 40px; flex-shrink: 0"
            >
              <i class="pi pi-indian-rupee" style="font-size: 1.2rem"></i>
            </div>
            <div>
              <div class="font-semibold text-700">Trade in INR</div>
              <div class="mt-2 opacity-70 text-muted line-height text-sm">
                No need to buy or hold crypto. Deposit INR directly from your
                bank account and start trading futures and options instantly.
              </div>
            </div>
          </div>
        </div>

        <div class="text-left" style="max-width: 25rem">
          <div class="flex align-items-start gap-3">
            <div
              class="bg-soft-orange border-round-md flex align-items-center justify-content-center"
              style="width: 40px; height: 40px; flex-shrink: 0"
            >
              <i class="pi pi-percentage" style="font-size: 1.2rem"></i>
            </div>
            <div>
              <div class="font-semibold text-700">50% Lower Brokerage</div>
              <div class="mt-2 opacity-70 text-muted line-height text-sm">
                Keep more of your profits with our competitive pricing—half the
                brokerage compared to other exchanges.
              </div>
            </div>
          </div>
        </div>

        <div class="text-left" style="max-width: 25rem">
          <div class="flex align-items-start gap-3">
            <div
              class="border-round-md flex align-items-center justify-content-center bg-soft-success"
              style="width: 40px; height: 40px; flex-shrink: 0"
            >
              <i class="pi pi-clock" style="font-size: 1.2rem"></i>
            </div>
            <div>
              <div class="font-semibold text-700">24/7 Markets</div>
              <div class="mt-2 opacity-70 text-muted line-height text-sm">
                Trade anytime, anywhere. Crypto markets never sleep, and neither
                does our platform—access it round the clock.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Compliance Section -->
  <section class="flex justify-content-center px-3 py-6 mt-4">
    <div class="text-center w-full" style="max-width: 70rem">
      <h2 class="text-2xl font-semibold text-700">Regulatory Compliance</h2>
      <div class="mt-4 text-muted opacity-70 line-height-3 font-medium">
        Coinwush operates in full compliance with Indian regulatory
        requirements. We are committed to maintaining the highest standards of
        legal and ethical conduct, ensuring a safe and transparent trading
        environment for all our users.
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="flex justify-content-center px-3 py-6 mt-4 mb-6 bg-white">
    <div class="text-center">
      <h2 class="text-2xl font-semibold text-700">Ready to Get Started?</h2>
      <div class="mt-4 text-muted opacity-70 line-height-3 font-medium">
        Join thousands of traders who trust Coinwush for their crypto
        derivatives trading
      </div>
      <div class="mt-6 flex justify-content-center gap-4">
        <div
          class="py-2 px-5 text-sm cursor-pointer highlight-bg border-round-sm text-center"
          (click)="navigate('/user/signup')"
        >
          Sign Up Now
        </div>
        <div
          class="py-2 px-5 font-medium text-700 cursor-pointer border-1 border-200 border-round-sm"
          (click)="navigate('/contact')"
        >
          Contact Us
        </div>
      </div>
    </div>
  </section>
</div>
